import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchContentModel } from "./SearchContentModel";
import SearchItem from "../SearchItem/SearchItem";
import Utils from "../../core/Utils/Utils";
import SearchUtils from "../SearchUtils";

import "./SearchContent.css";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

const SearchContent: React.FC = () => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [data, setData] = useState<SearchContentModel[]>([]);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const location = useLocation();
  const navigate = useNavigate();

  const handlePrevPage = () => {
    if (page > 1) {
      const value = page - 1;
      Utils.setNavidation([{ param: "page", value: value.toString() }]);
      setPage(value);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      const value = page + 1;
      Utils.setNavidation([{ param: "page", value: value.toString() }]);
      setPage(value);
    }
  };

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get("query") || "";
    const pageParam = params.get("page") || 1;
    setSearchTerm(query);
    setPage(Number(pageParam));

    SearchUtils.getCachedOrStoryblokSearch(
      query,
      itemsPerPage,
      Number(pageParam)
    )
      .then((response: any) => {
        setTotalItems(response?.data?.total || response.headers.total);
        setData(response?.data?.story || response.data.stories);
      })
      .catch((error) => {
        if (error.status === 404) {
          navigate("/404");
        } else if (error.status === 500) {
          navigate("/500");
        }
      });
  }, [page, location, navigate]);

  return (
    <div
      className="search-content"
      style={{ backgroundColor: theme?.panelColour, color: theme?.textColor }}
    >
      <div className="container">
        <div className="search-header">
          <div className="search-header-left">
            SEARCH: “{searchTerm?.toUpperCase()}”
          </div>
          <div className="search-header-right">
            <div className="search-results">{totalItems} RESULTS</div>
            {page > 1 && (
              <span className="search-arrow" onClick={handlePrevPage}>
                &#9204;
              </span>
            )}
            <div className="search-pages">
              {page.toString()} / {totalPages}
            </div>
            {page < totalPages && (
              <span className="search-arrow" onClick={handleNextPage}>
                &#9205;
              </span>
            )}
          </div>
        </div>
        {data &&
          data.map((item) => (
            <SearchItem blok={item} key={item.uuid}></SearchItem>
          ))}
      </div>
    </div>
  );
};

export default SearchContent;
